import { SearchOutlined } from '@ant-design/icons';
import { Select, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import DateRangePickerField from 'components/Global/DateRangePicker';
import SearchComponent from 'components/Global/SearchComponent';
import styles from './index.module.scss';
import { paymentOptions } from 'utils/utils';

type Props = {
	searchText: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => void;
	dateRange: [Dayjs, Dayjs];
	onDateRangeChange: (value: [Dayjs, Dayjs] | null) => void;
	filterOptions: string;
	handleStatusFilter: (value: string) => void;
	handleBankType: (value: string) => void;
	bankType: string;
};

const PaymentTableHeader = (props: Props) => {
	const {
		searchText,
		handleSearch,
		handleSearchApi,
		dateRange,
		onDateRangeChange,
		filterOptions,
		handleStatusFilter,
		handleBankType,
		bankType,
	} = props;

	return (
		<div className={styles['employee-header']}>
			<Space wrap>
				<SearchComponent
					className={styles['employee-header-item']}
					placeHolder="Search by employee name or code"
					prefixIcon={<SearchOutlined />}
					handleChange={handleSearch}
					handleChangeApi={handleSearchApi}
					value={searchText}
					size="large"
				/>
				<DateRangePickerField
					name="paymentLogsDateRange"
					value={dateRange as unknown as string}
					required={false}
					isError={false}
					onChange={(value) => {
						onDateRangeChange(
							(value as unknown) as [dayjs.Dayjs, dayjs.Dayjs] | null
						);
					}}
				/>
				<Select
					className={styles['employee-header-item']}
					value={filterOptions}
					style={{
						width: '150px',
					}}
					options={paymentOptions}
					onChange={(value) => {
						handleStatusFilter(value);
					}}
					size="large"
					placeholder="Select by supervisor"
				/>
				<Select
					className={styles['employee-header-item']}
					value={bankType}
					style={{
						width: '160px',
					}}
					options={[
					
						{
							label: 'Stanbic Bank',
							value: 'STANBIC',
						},
						{
							label: 'First Capital Bank',
							value: 'FCB',
						}
					]}
					onChange={(value) => {
						handleBankType(value);
					}}
					size="large"
					placeholder="Select by supervisor"
				/>
			</Space>
		</div>
	);
};

export default PaymentTableHeader;
